import colors from "../styles/colors";

const statusColors = {
  active: colors.red.general,
  complete: colors.green.general,
};

export default statusColors;
